import type { IntlShape } from "@formatjs/intl";
import type { HookAPI } from "antd/es/modal/useModal";
import { type State as RouterState } from "router5";
import { ClientInformation } from "./ClientInformation";
import type {
  Client,
  PaginatedticketResultsSideloadList,
  PaginatedturbineResultsSideloadList,
  Project,
  Services,
} from "../../generated-axios-client/index.ts";
import type { SideloadedTicketInfo } from "../../../features/ticket/ticketSlice";
import type { SideloadedTurbineInfo } from "../../../features/turbine/turbineSlice";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { PageTitleContainer } from "../../../common/components/PageTitle.tsx";
import { actions } from "redux-router5";
import { routeNames } from "../../common/routes.ts";
import type { Dispatch } from "@reduxjs/toolkit";

export type ClientData = {
  client: Client;
  tickets: PaginatedticketResultsSideloadList;
  turbines: PaginatedturbineResultsSideloadList;
  ticketSideload: SideloadedTicketInfo;
  turbineSideload: SideloadedTurbineInfo;
  serviceObjects: Record<string, Services> | null;
  clientProjects: Project[];
};

export type ClientViewRenderProps = {
  intl: IntlShape;
  currentRoute: RouterState | null;
  clientData: ClientData;
  modalApi: HookAPI | undefined;
};

type ClientViewRenderPageProps = ClientViewRenderProps & {
  dispatch: Dispatch;
};

export const ClientViewRender = (props: ClientViewRenderPageProps) => {
  const { intl, currentRoute, clientData, modalApi, dispatch } = props;
  const { client } = clientData;

  return (
    <PageTitleContainer
      title={client.legal_name}
      subtitle={client.tax_id}
      extra={
        <Button
          icon={<EditOutlined />}
          onClick={() =>
            dispatch(actions.navigateTo(routeNames.CLIENT_EDIT, { id: client.id }))
          }
        >
          {intl.formatMessage({ id: "client_edit_title" })}
        </Button>
      }
    >
      <ClientInformation
        currentRoute={currentRoute}
        intl={intl}
        clientData={clientData}
        modalApi={modalApi}
        dispatch={dispatch}
      />
    </PageTitleContainer>
  );
};
